import React from 'react';
import { Box, Grid } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Skeleton } from '@mui/material';

const useStyles = makeStyles((theme) => ({
  root: {
    overflowY: 'hidden',
    paddingTop: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    marginLeft: theme.spacing(1),
    width: '100%'
  },
  contentBox: {
    width: '100%',
    height: 60,
    borderRight: `1px solid ${theme.palette.divider}`,
    borderBottom: `1px solid ${theme.palette.divider}`,
    borderLeft: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.secondary,
    paddingRight: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    marginLeft: theme.spacing(1),
    paddingBottom: theme.spacing(-2)
  },
  box: {
    height: theme.spacing(8),
    justifyContent: 'center',
    display: 'flex'
  },
  daySkeleton: {
    height: theme.spacing(4),
    marginTop: theme.spacing(-2.0),
    background: theme.skelton?.color,
    width: 50
  },
  taskSkeleton: {
    background: theme.skelton?.color,
    height: theme.spacing(3),
    width: theme.spacing(40)
  },
  labelSkeleton: {
    marginRight: theme.spacing(1),
    background: theme.skelton?.color,
    width: theme.spacing(14),
    height: theme.spacing(3),
    borderRadius: theme.spacing(1)
  },
  dayRow: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    background: theme.palette.grey[100],
    height: '100%',
    borderTop: '2px solid #bdcaad',
    borderBottom: '2px solid #bdcaad',
    borderLeft: '2px solid #bdcaad'
  },
  avatar: {
    background: theme.skelton?.color,
    width: theme.spacing(5.5),
    height: theme.spacing(5.5),
    alignSelf: 'center',
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1)
  }
}));

const NotesTimelineDaySkeleton: React.FC = () => {
  const classes = useStyles();
  const dataRows = [1, 4];
  return (
    <Box className={classes.root} data-testid={'notes-timeline-day-skeleton'}>
      {Array.from(new Array(16)).map((_item, rowIndex) => {
        return (
          <Box key={`timeline_row_${rowIndex}`} className={classes.box}>
            <Skeleton className={classes.daySkeleton} />
            <div className={classes.contentBox}>
              {dataRows.includes(rowIndex) && (
                <div className={classes.dayRow}>
                  <Skeleton variant={'circular'} className={classes.avatar} />
                  <div>
                    <Skeleton className={classes.taskSkeleton} />
                    <Grid container>
                      {Array.from(new Array(3)).map((item, index) => (
                        <Skeleton
                          key={`timeline_cell_${index}`}
                          className={classes.labelSkeleton}
                        />
                      ))}
                    </Grid>
                  </div>
                </div>
              )}
            </div>
          </Box>
        );
      })}
    </Box>
  );
};

export default NotesTimelineDaySkeleton;
